module.exports = __webpack_public_path__ + "img/Jimmy.0b53821f.png";